module.exports = __webpack_public_path__ + "static/media/website-primary.67132f19.svg";